(function () {
  const slugify = (str) =>
    str.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .substring(0, 80);

  const uniqueId = (base, used) => {
    let id = base, i = 2;
    while (used.has(id) || document.getElementById(id)) id = `${base}-${i++}`;
    used.add(id);
    return id;
  };

  const selectFirst = (selectors) => {
    for (const s of selectors.split(',')) {
      const el = document.querySelector(s.trim());
      if (el) return el;
    }
    return null;
  };

  const smoothScrollWithOffset = (target, offset = 80) => {
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  document.addEventListener('DOMContentLoaded', () => {
    const tocRoot = document.getElementById('shopify-toc');
    if (!tocRoot) return;

    const containerSel = tocRoot.getAttribute('data-toc-target') || '.rte';
    const container = selectFirst(containerSel);
    if (!container) return;

    const headings = Array.from(container.querySelectorAll('h2'))
      .filter(h => h.textContent && getComputedStyle(h).display !== 'none');

    if (headings.length < 3) return;

    const used = new Set();
    headings.forEach(h => {
      if (!h.id || document.querySelectorAll(`#${CSS.escape(h.id)}`).length > 1) {
        const base = slugify(h.textContent);
        h.id = uniqueId(base || 'section', used);
      }
    });

    const nav = tocRoot.querySelector('.toc__body');
    const stack = [];
    const getLevel = (tag) => ({ h2: 2, h3: 3, h4: 4 }[tag.toLowerCase()] || 6);

    const rootUL = document.createElement('ul');
    rootUL.className = 'toc__list';
    nav.appendChild(rootUL);
    stack.push({ level: 2, ul: rootUL });

    headings.forEach(h => {
      const lvl = getLevel(h.tagName);
      let current = stack[stack.length - 1];

      if (lvl > current.level) {
        for (let l = current.level + 1; l <= lvl; l++) {
          const newUL = document.createElement('ul');
          newUL.className = 'toc__list';
          const parentLI = current.ul.lastElementChild || current.ul.appendChild(document.createElement('li'));
          parentLI.appendChild(newUL);
          current = { level: l, ul: newUL };
          stack.push(current);
        }
      } else if (lvl < current.level) {
        while (stack.length && stack[stack.length - 1].level > lvl) stack.pop();
        current = stack[stack.length - 1] || { level: 2, ul: rootUL };
      }

      const li = document.createElement('li');
      li.className = `toc__item toc__item--lvl${lvl}`;
      const a = document.createElement('a');
      a.className = 'toc__link';
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--toc-offset') || '80', 10);
        smoothScrollWithOffset(h, offset);
        history.replaceState(null, '', `#${h.id}`);
      });
      li.appendChild(a);
      current.ul.appendChild(li);
    });

    // Affiche le TOC (il était caché par .toc--hidden)
    tocRoot.classList.remove('toc--hidden');

    // Surbrillance section active
    let ticking = false;
    const anchors = headings.map(h => ({ id: h.id, top: h.offsetTop }));
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const pos = window.scrollY + 100;
        let activeId = anchors[0]?.id;
        for (const a of anchors) if (a.top - 110 <= pos) activeId = a.id; else break;
        nav.querySelectorAll('.toc__link--active').forEach(el => el.classList.remove('toc__link--active'));
        const active = nav.querySelector(`a[href="#${CSS.escape(activeId)}"]`);
        if (active) active.classList.add('toc__link--active');
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();